// Module
var code = "<md-icon md-svg-icon=\"location-pin-outline\" class=\"bringoz-icon\" ng-class=\"$ctrl.purpose\"></md-icon> ";
// Exports
export default code;